module.exports = __webpack_public_path__ + "static/img/settings-grey.603598a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/settings-grey.svg
// module id = 620
// module chunks = 2